// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'exchange-case-user';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m3.265 3.593.969-1.938A1.415 1.415 0 0 1 5.64.718h.937a1.416 1.416 0 0 1 1.407.937l.969 1.938M.713 6.468h10.542m-5.271 0v1.489M16.526 4.38h.24a4.073 4.073 0 0 1 4.072 4.073M6.223 20.671l1.917-1.916-1.917-1.917' />
    <path d='M14.995 14.275a2.669 2.669 0 1 0 5.338 0 2.669 2.669 0 1 0-5.338 0m7.292 8.007a4.67 4.67 0 0 0-9.246 0ZM1.362 3.593h9.244s.649 0 .649.649v5.65s0 .649-.65.649H1.363s-.649 0-.649-.65v-5.65s0-.648.649-.648m15.402-1.13L14.848 4.38l1.917 1.916M6.463 18.755a4.313 4.313 0 0 1-4.313-4.313' />
  </g>
);

export const viewBox = '-0.5 -0.5 24 24';
